module.exports = __webpack_public_path__ + "img/jelly.fb17ea59.png";